import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import ImportDialog from '@/components/importDialog'
import { deleteActivityCodes, updateActivityCodes} from '../api'


const commonAction = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '提交', key: 'save', type: 'primary', size: 'default' }
]

export const tableSetting = (vm) => createSetting({
  columns: [
    {
      name: '顺丰微派任务编码',
      key: 'task_code',
      minWidth: 150
    },
    {
      name: '说明',
      key: 'task_desc',
      minWidth: 150
    },
    {
      name: '关联商品',
      key: '',
      minWidth: 140,
      render: (h, {row}) => {
        return (
          <div>
            已关联 {row.goods_count} 个商品
            <el-button
              style={{ marginLeft: '10px' }}
              type='text'
              on-click={() => vm.showGoods(row)}
            >
              查看
            </el-button>
            <ImportDialog
              buttonName='导入商品'
              buttonSize='medium'
              fileName='导入商品'
              buttonType='text'
              fileType='weipai_task_items'
              relId={row.id}
            />
          </div>
        )
      }
    },
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `编辑顺丰国补编码`,
            width: '50%',
            orgData: rows[0],
            component: () => import('../comps/createForm.vue'),
            actions: commonAction
          }).then(async (arg) => {
            if(arg) {
              console.log(arg, 'edit_arg')
              try {
                await updateActivityCodes(arg)
                vm.$message.success('保存成功')
                vm.refresh()
              } catch (error) {
                console.log(error)
              }
            }
          })
        }
      }
    },
    {
      name: '添加商品',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          vm.addItems(rows[0])
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前数据？', '提示').then(async () => {
            const task_code = rows[0].task_code
            await deleteActivityCodes(task_code)
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
  ]
})
